export default __webpack_public_path__ + "static/media/DogPawIcon.9686bd74.svg";